import React from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { logoutAction } from "../../../store/actions/AuthActions";
import { isAuthenticated } from "../../../store/selectors/AuthSelectors";
import swal from "sweetalert";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function LogoutPage(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function onLogout() {
    // Show SweetAlert confirmation dialog
    // swal({
    //   title: "Are you sure?",
    //   text: "You will be logged out!",
    //   icon: "warning",
    //   buttons: true,
    //   dangerMode: true,
    // }).then((willLogout) => {
    //   if (willLogout) {
    //     dispatch(logoutAction());
    //     navigate("/login");
    //     // Optionally, you can reload the page
    //     // window.location.reload();
    //   } else {
    //     swal("You are still logged in!");
    //   }
    // });
    swal({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willLogout) => {
      if (willLogout) {
        dispatch(logoutAction());  // Already updated to handle API call
        navigate("/login");
      } else {
        swal("You are still logged in!");
      }
    });
    
  }

  return (
    <>
      <button className="dropdown-item ai-icon" onClick={onLogout}>
        <svg
          id="icon-logout"
          xmlns="http://www.w3.org/2000/svg"
          className="text-danger"
          width={18}
          height={18}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1={21} y1={12} x2={9} y2={12} />
        </svg>
        <span className="ms-2">Logout</span>
      </button>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(LogoutPage));
